import React, { useEffect, useState } from "react";
import {
  fetch_services,
  export_services,
  search_services,
  delete_service,
} from "../../../../services/clinic/services";
import { useParams, useSearchParams } from "react-router-dom";
import ItemListingTable, {
  getTableUpdateCallback,
} from "../../common/ItemListingTable";
import ListingPageControls from "../../common/ListingPageControls";
import { notify_promise } from "../../../../services/utils/toasts";

const ServiceListingPage = () => {
  const { parentCategoryID } = useParams();

  const [fields, setFields] = useState([]);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search"));
  const [latestSearchQuery, setLatestSearchQuery] = useState(
    searchParams.get("search")
  );
  const [parentCategory, setParentCategory] = useState("Services");
  const [perPage, setPerPage] = useState(10);

  const apiCall = [
    fetch_services,
    {
      page: 0,
      parent_category_id: parentCategoryID,
      search: search ? search : "",
      perPage: perPage,
    },
  ];
  const deleteItem = (id) => {
    notify_promise(
      new Promise((resolve, reject) => {
        delete_service([id])
          .then((res) => {
            setData((prev) => {
              return prev.filter((p) => {
                return p.id !== id;
              });
            });
            resolve(res);
          })
          .catch(reject);
      })
    );
  };

  const updateTableInfo = getTableUpdateCallback({
    apiCall: apiCall,
    dataSetter: setData,
    paginationSetter: setPagination,
    fieldSetter: setFields,
    categorySetter: setParentCategory,
    buttons: [
      // { template: "view-modal" },
      {
        template: "edit",
        getRedirectURL: (id) => {
          return "/admin/services/edit/:id";
        },
      },
      {
        template: "delete",
        onClick: (id) => {
          deleteItem(id);
        },
      },
    ],
  });

  useEffect(() => {
    setSearch(searchParams.get("search"));
  }, [searchParams.get("search")]);

  useEffect(() => {
    setLatestSearchQuery(search);
  }, [search]);

  useEffect(() => {
    updateTableInfo(0);
  }, [latestSearchQuery, perPage]);

  return (
    <div className="page-content py-3 px-4 bg-lightgray">
      <ListingPageControls
        exportApi={export_services}
        type="service"
        addNewLink="/admin/services/add"
        hasTitle={true}
        title={parentCategory}
        resultType="service"
        setSearch={setSearchParams}
      />
      <ItemListingTable
        updateTableInfo={updateTableInfo}
        fields={fields}
        data={data}
        pagination={pagination}
        setPerPage={setPerPage}
        perPage={perPage}
      />
    </div>
  );
};

export default ServiceListingPage;
